import "../App.css";
import { useAuth } from "../contexts/AuthContext";
import { Container, Row, Col, Image, Nav, Button } from "react-bootstrap";
// 1. Swap 'Link' for 'NavLink'
import { NavLink } from "react-router-dom"; 

function Header({ onLoginClick }) {
  const { currentUser, logout } = useAuth();
  return (
    <Container className="header" fluid>
      <Row>
        <Col xs={12} md={4} className="text-center text-md-start">
          <Image src="/logo_large.png" alt="MUSC NCVRTC Logo" fluid />
        </Col>
        <Col className="d-flex flex-column mb-5">
          <Row>
            <Col>
              <Nav
                variant="underline"
                className="justify-content-center justify-content-md-end"
              >
                <Nav.Item>
                  {currentUser ? (
                    <Nav.Link as={NavLink} className="navbar-link" to="/">
                      Dashboard
                    </Nav.Link>
                  ) : (
                    <Nav.Link as={NavLink} className="navbar-link" to="/">
                      Home
                    </Nav.Link>
                  )}
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} className="navbar-link" to="/about">
                    About
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} className="navbar-link" to="/ceustatement">
                    CEU Statement
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} className="navbar-link" to="/contact">
                    Contact
                  </Nav.Link>
                </Nav.Item>
                {currentUser ? (
                  <Button className="log-button ms-2" onClick={logout}>
                    Logout
                  </Button>
                ) : (
                  <Button className="log-button ms-2" onClick={onLoginClick}>
                    Login
                  </Button>
                )}
              </Nav>
            </Col>
          </Row>

          <Row className="mt-auto">
            <Col>
            {currentUser ? (
              <p className="user-email text-center text-md-end mt-2 mt-md-0">
                Welcome, {currentUser?.user?.username}! ({currentUser?.user?.email})
              </p>
            ) : (
              <div></div>
            )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Header;
